<template>
  <div class="tag-content" v-on="$listeners">
    <ReviewBoosterTooltip
      v-if="isAutoAssigned"
      :text="$t('message.reviews.autCategorizationEnabled')"
    >
      <v-icon color="black" class="mr-2">icon-robot</v-icon>
    </ReviewBoosterTooltip>

    <ReviewBoosterTooltip :text="name" :disabled="!isTextOverflow">
      <div class="tag-content__name">
        {{ tagName }}
      </div>
    </ReviewBoosterTooltip>
  </div>
</template>

<script>
import ReviewBoosterTooltip from "./ReviewBoosterTooltip";
export default {
  name: "ReviewBoosterTagItemContent",
  components: {
    ReviewBoosterTooltip
  },
  props: {
    name: {
      type: String,
      required: true
    },
    maxCharacters: {
      type: Number,
      default: 15
    },
    isAutoAssigned: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { localValue: null };
  },
  computed: {
    isTextOverflow() {
      return this.name.length > this.maxCharacters;
    },
    tagName() {
      return this.isTextOverflow
        ? this.name.substring(0, this.maxCharacters) + "..."
        : this.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-content {
  padding: 0 $spacing * 2;
  display: flex;
  align-items: center;

  &__name {
    @include font-size(14px);
    color: $dark-blue-3;
    font-weight: 500;
    text-overflow: ellipsis;
  }
}
</style>
